module.exports = __webpack_public_path__ + "img/8501.3f22e15c.jpg";